module.exports = __webpack_public_path__ + "img/pack-num.83c85655.png";